import FlagInappropriate from './FlagInappropriate'

export default FlagInappropriate
